import cn from "clsx";
import { useTranslations } from "next-intl";
import Link from "next/link";
import React from "react";

import { productTestIds } from "@/features/product/test-ids";
import { ROUTES } from "@/features/store/settings/routes";

export const BespokeLink: React.FC<{
  onClick?: () => void;
  className?: string;
  questionClassName?: string;
  actionClassName?: string;
}> = ({ onClick, questionClassName = "", actionClassName = "", className = "" }) => {
  const t = useTranslations("common");

  return (
    <Link
      data-testid={productTestIds.bespokeLink}
      href={ROUTES.BESPOKE}
      className={cn("text-grey flex flex-col items-center gap-y-3 text-base", className)}
      onClick={onClick}
    >
      <span className={cn("text-center ", questionClassName)}>
        {t("text-page-bespoke-sub-heading")}
      </span>
      <span className={cn(actionClassName)}>
        {t("text-page-bespoke-main-heading")} {">"}
      </span>
    </Link>
  );
};
